<div class="row">
  <div class="col-md-12 text-right mb-2" *ngIf="!(verificationObj && verificationObj[section.fieldID] == 3)">
    <button (click)="addToTable(form_group,section.fieldID,section.multiple_form)"
      class="btn btn-sm mat-mt js-btn-save">
      <i class="fa fa-plus-square mx-1"></i>
      {{'BTN.add'|translate}}
    </button>
  </div>

</div>

<div class="col-md-12 tm-data-table table-responsive">
  <table *ngIf="form_group.get(section.fieldID).value" class="table">
    <thead>
      <tr>
        <th class="text-center" scope="col" *ngIf="!(verificationObj && verificationObj[section.fieldID] == 3)">
          Action
        </th>
        <th scope="col" *ngFor="let field of columns">
          {{field.label}}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of form_group.get(section.fieldID).value  || [];let i = index">
        <ng-container *ngIf=" form_group.get(section.fieldID).value.length;else nodata">
          <ng-container
            *ngTemplateOutlet="tr; context: {row: item,i:i,form_group:form_group,section:section,masters:masters}">
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>




<ng-template #tr let-display_row="row" let-i="i" let-form_group="form_group" let-section="section"
  let-masters="masters">
  <tr>
    <td class="text-center" *ngIf="!(verificationObj && verificationObj[section.fieldID] == 3)">
      <button class="btn btn-sm btn-default mx-1 "
        (click)="editTableItem(i,form_group,section.fieldID,section.multiple_form)">
        <i class="fa fa-pencil mx-1"></i>
        {{'BTN.edit'|translate}}
      </button>
      <button class="btn btn-sm btn-default mx-1 "
        (click)="deleteTableItem(i,form_group,section.fieldID,section.multiple_form)">
        <i class="fa fa-trash orange mx-1"></i>
        {{'BTN.delete'|translate}}
      </button>
    </td>
    <!--'font-weight-bold': nested==true && display_row.child==0-->
    <ng-container *ngFor="let column of columns; let index=index;">
      <td [id]=" 'tallite-td'+ column.fieldID" [attr.data-label]="column.label+' : '"
        [ngClass]="{'pointer link':column.functionName && column.functionName!=''}"
        [ngStyle]=" column.gridStyle ? (column.gridStyle |checkStyle : display_row:column):null ">
        <!-- <div [ngStyle]="{'width': column.gridWidth > 20 ? column.width+'px' : '100px'}"
          class="column-header tallint-data-grid " [ngClass]="{'text-right right-me-lelo':column.dataTypeId=='int'}"
          [class]="column.cell_class" style="border-right: 3px solid transparent;"> -->
        <ng-container *ngIf="column.dataTypeId ==1;else checkDate">
          <span class="margin" [title]="display_row[column.fieldID]">
            <span [innerHTML]='display_row[column.fieldID]| HTMLFormatter'>
            </span>
          </span>
        </ng-container>
        <ng-template #checkDate>
          <ng-container *ngIf="column.dataTypeId ==3;else checkDateTime">
            <span class="column-title" [title]="(display_row[column.fieldID])  | date: 'd-MMM-yyyy'">
              {{(display_row[column.fieldID])| date: 'd-MMM-yyyy'}}
            </span>
          </ng-container>
        </ng-template>
        <ng-template #checkDateTime>
          <ng-container *ngIf="column.dataTypeId ==4;else checkTime">
            <span class="column-title"
              [title]="display_row[column.fieldID]  | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'">
              {{(display_row[column.fieldID]) | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
            </span>
          </ng-container>
        </ng-template>
        <ng-template #checkTime>
          <ng-container class="column-title" *ngIf="column.dataTypeId =='time';else checknvarchar;">
            <span [title]="display_row[column.fieldID]  | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'">
              {{(display_row[column.fieldID]) | UtcToLocalTime | date: 'h:mm a'}}
            </span>
          </ng-container>
        </ng-template>

        <ng-template #checknvarchar>
          <ng-container *ngIf="column.dataTypeId ==1;else checkvarbinary;">
            <span class="margin column-header">
              <span class="column-title" [innerHTML]='display_row[column.fieldID]| HTMLFormatter'>
              </span>
            </span>
          </ng-container>
        </ng-template>

        <ng-template #checkvarbinary>
          <ng-container *ngIf="column.dataTypeId ==5;else checkHtmlTemplate;">
            <span class="column-title link" [title]="display_row[column.fieldID] | DynamicFilesTitlePipe"
              (click)="view(display_row[column.fieldID])">
              {{(display_row[column.fieldID]) | DynamicFilesTitlePipe}}
            </span>
          </ng-container>
        </ng-template>
        <ng-template #checkHtmlTemplate>
          <ng-container *ngIf="column.dataTypeId ==10;else checkPhoneNumber;">
            <div class="margin"
              [innerHTML]="((column.style |checkTemplate : display_row:column)| HTMLFormatter)|SanitizePipe :'html'">
            </div>
          </ng-container>
        </ng-template>

        <ng-template #checkPhoneNumber>
          <ng-container *ngIf="column.dataTypeId ==11;else dropdown;">
            <div class="margin">

              {{ display_row[column.fieldID] | DynamicPipe: masters[column['masterPropName']] :(column['id_property'] ||
              'id'):(column['title_property'] || 'title')}}
              {{display_row[column.numberControl]}}
            </div>
          </ng-container>
        </ng-template>


        <ng-template #dropdown>
          <ng-container *ngIf="column.dataTypeId ==8;else tmCheckbox;">

            {{ display_row[column.fieldID] | DynamicPipe: masters[column['masterPropName']] :(column['id_property'] ||
            'id'):(column['title_property'] || 'title')}}
          </ng-container>

        </ng-template>

        <ng-template #tmCheckbox>
          <ng-container *ngIf="column.dataTypeId ==13;else monthYear;">
            <ng-container *ngIf="display_row[column.fieldID]">
              <i class="fa checkbox-icons fa-check-square-o"></i>
            </ng-container>

          </ng-container>

        </ng-template>

        <ng-template #monthYear>
          <ng-container class="column-title" *ngIf="column.dataTypeId ==19;else noDataType;">
            <span [title]="display_row[column.fieldID]  | UtcToLocalTime | date: 'MMM-yyyy'">
              {{(display_row[column.fieldID]) | UtcToLocalTime | date: 'MMM-yyyy'}}
            </span>
          </ng-container>
        </ng-template>

        <ng-template #noDataType>
          <span [title]="display_row[column.fieldID]">
            {{display_row[column.fieldID]}}
          </span>
        </ng-template>
      </td>
    </ng-container>

  </tr>
</ng-template>

<ng-template #nodata>

  <div> No records found!</div>
</ng-template>